import { render, staticRenderFns } from "./MarketSetCard.vue?vue&type=template&id=8fc8b3fc&"
import script from "./MarketSetCard.vue?vue&type=script&lang=js&"
export * from "./MarketSetCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports